import { z } from "zod";

const searchScalarSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
]);

const searchEntrySchema = z.union([
    searchScalarSchema,
    z.record(z.string(), searchScalarSchema),
]);

export const matchSearchSchema = z.record(
    z.string(),
    z.union([searchEntrySchema, z.array(searchEntrySchema)]).optional(),
);

export type MatchSearch = z.infer<typeof matchSearchSchema>;

export const locatedMatchSearchSchema = z.looseObject({
    lat: z.number(),
    lng: z.number(),
});

export const rememberedMatchSearchSchema = z.object({
    owner: z.string(),
    search: matchSearchSchema,
});

export type RememberedMatchSearch = z.infer<typeof rememberedMatchSearchSchema>;
